import type { FilterOption } from './filter-option';
import type { FilterMultiValue, FilterSingleValue } from './filter-option';
import type { FilterConfig } from './filter-config';

export class FilterModel<Key extends string = string> {
    public readonly isMultiple: boolean = false;
    public readonly type: FilterConfig['type'] = 'select';

    constructor(
        public readonly key: Key,
        public readonly title: string,
        public readonly values: Array<FilterOption>,
    ) { }

    public static from<Key extends string = string>(filter: { key: Key; title: string; values: Array<FilterOption> }): FilterModel<Key> {
        return new FilterModel(filter.key, filter.title, filter.values);
    }

    public getValue(): FilterSingleValue {
        return this.values[0]?.value ?? null;
    }

    public getValues(): FilterMultiValue {
        return this.values.map(item => item.value);
    }
}

export class MultiFilterModel<Key extends string = string> extends FilterModel<Key> {
    public override readonly isMultiple = true as const;
    public override readonly type = 'multiselect';
}

export class SelectFilterModel<Key extends string = string> extends FilterModel<Key> {
    public override readonly isMultiple = false as const;
    public override readonly type = 'select';
}

export class SearchFilterModel<Key extends string = string> extends FilterModel<Key> {
    public override readonly isMultiple = false as const;
    public override readonly type = 'search';
}
